export const LEVEL_OF_SATISFACTION = {
    very: {
        en: 'Very satisfied',
        es: 'Muy satisfecho'
    },
    some: {
        en: 'Somewhat satisfied',
        es: 'Algo satisfecho'
    },
    neither: {
        en: 'Neither satisfied nor dissatisfied',
        es: 'Ni satisfecho ni insatisfecho'
    },
    some_dis: {
        en: 'Somewhat dissatisfied',
        es: 'Algo insatisfecho'
    },
    very_dis: {
        en: 'Very dissatisfied',
        es: 'Muy insatisfecho'
    }
} as Record<string, { en: string; es: string }>;
